import React from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const ImagenAmpliable = ({ src, alt = '', estiloMiniatura = {}, estiloImagen = {} }) => {
    return (
        <Zoom>
            <img
                src={src}
                alt={alt}
                loading="lazy"
                style={{
                    maxWidth: '100px',
                    cursor: 'zoom-in',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    ...estiloMiniatura,
                    ...estiloImagen
                }}
            />
        </Zoom>
    );
};

export default ImagenAmpliable;
